<template>
  <section v-if="name === 'special'" class="section">
    <div class="section-header with-border">
      专题配置
    </div>
    <div class="section-body">
      <el-form label-width="100px">
        <div style="margin-top:20px;font-size:14px;color:red">全局配置</div>
        <el-form-item label="背景色">
          <el-input v-model="config.bg.backColor" type="text"></el-input>
        </el-form-item>
        <el-form-item label="背景图片">
          <div class="setting-item slider">
            <img v-if="config.bg.backImg" :src="wximageurl + config.bg.backImg" class="banner-uploader" @click="handleSpecialBgImgChange(0)"/>
            <div class="banner-uploader" v-else @click="handleSpecialBgImgChange(0)">
              <i class="iconfont icon-camera"></i>上传图片
            </div>
          </div>
        </el-form-item>
        <el-form-item label="角标">
          <el-radio-group v-model="config.bg.icon" @change="styleBgIconChange">
            <el-radio :label="0">不显示</el-radio>
            <el-radio :label="1">左上角标</el-radio>
            <el-radio :label="2">右上角标</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="左上角标">
          <div class="setting-item slider">
            <img v-if="config.bg.leftIconUrl" :src="wximageurl + config.bg.leftIconUrl" class="banner-uploader" @click="handleLeftIconUrlImgChange(4)"/>
            <div class="banner-uploader" v-else @click="handleLeftIconUrlImgChange(4)">
              <i class="iconfont icon-camera"></i>上传图片
            </div>
          </div>
        </el-form-item>
        <el-form-item label="右上角标">
          <div class="setting-item slider">
            <img v-if="config.bg.rightIconUrl" :src="wximageurl + config.bg.rightIconUrl" class="banner-uploader" @click="handlerightIconUrlImgChange(3)"/>
            <div class="banner-uploader" v-else @click="handlerightIconUrlImgChange(3)">
              <i class="iconfont icon-camera"></i>上传图片
            </div>
          </div>
        </el-form-item>
        <div style="margin-top:20px;font-size:14px;color:red">秒杀配置</div>
        <el-form-item label="排列">
          <el-radio-group v-model="config.flashSale.direction" @change="styleFlashSaleChange">
            <el-radio :label="'row'">竖排</el-radio>
            <el-radio :label="'vertical'">横排</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="横排背景图">
          <div class="setting-item slider">
            <img v-if="config.flashSale.backImg" :src="wximageurl + config.flashSale.backImg" class="banner-uploader" @click="handleFlashSaleBgImgChange(1)"/>
            <div class="banner-uploader" v-else @click="handleFlashSaleBgImgChange(1)">
              <i class="iconfont icon-camera"></i>上传图片
            </div>
          </div>
        </el-form-item>
        <el-form-item label="横排背景内距">
          <el-input v-model="config.flashSale.padding" type="text"></el-input>
        </el-form-item>
        <div style="margin-top:20px;font-size:14px;color:red">优惠券配置</div>
        <el-form-item label="2张排列">
          <el-radio-group v-model="config.coupon.directionTwo" @change="styleCouponTwoDisplayChange">
            <el-radio :label="'1'">横向</el-radio>
            <el-radio :label="'2'">竖向</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="3张排列">
          <el-radio-group v-model="config.coupon.directionThree" @change="styleCouponDisplayChange">
            <el-radio :label="'1'">一排三列</el-radio>
            <el-radio :label="'2'">上一下二</el-radio>
            <el-radio :label="'3'">上二下一</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="4张排列">
          <el-radio-group v-model="config.coupon.directionFour" @change="styleCouponFourDisplayChange">
            <el-radio :label="'tile'">两排两列</el-radio>
            <el-radio :label="'scroll'">滑动</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="4张滑动背景">
          <div class="setting-item slider">
            <img v-if="config.coupon.backImg" :src="wximageurl + config.coupon.backImg" class="banner-uploader" @click="handleCouponBgImgChange(2)"/>
            <div class="banner-uploader" v-else @click="handleCouponBgImgChange(2)">
              <i class="iconfont icon-camera"></i>上传图片
            </div>
          </div>
        </el-form-item>
        <el-form-item label="4张滑动背景内距">
          <el-input v-model="config.coupon.padding" type="text"></el-input>
        </el-form-item>
      </el-form>



    </div>
  </section>
</template>

<script>
  export default {
    props: {
      res: {
        type: Object,
        default: {}
      }
    },
    watch: {
      res: {
        deep: true,
        handler (value) {
          if (value) {
            this.setData(value)
          }
        }
      }
    },
    data () {
      return {
        name: '',
        padded: false,
        config: {},
        data: [],
      }
    },
    methods: {
      setData(val) {
        this.name = val.name
        this.base = val.base
        this.config = val.config
        this.data = val.data
      },
      removeItem (index) {
        this.data.splice(index, 1)
      },



      //专题背景
      handleSpecialBgImgChange(index) {
        this.$emit('bindImgs', index)
      },
      //角标
      styleBgIconChange(data) {
        this.config.bg.icon = data
      },
      //左角标图片
      handleLeftIconUrlImgChange(index) {
        this.$emit('bindImgs', index)
      },
      //右角标图片
      handlerightIconUrlImgChange(index) {
        this.$emit('bindImgs', index)
      },
      //秒杀背景
      handleFlashSaleBgImgChange(index) {
        this.$emit('bindImgs', index)
      },
      //秒杀排列
      styleFlashSaleChange(data) {
        if (data == 'row') {
          this.config.flashSale.direction = 'row'
        } else {
          this.config.flashSale.direction = 'vertical'
        }
      },
      //优惠券背景
      handleCouponBgImgChange(index) {
        this.$emit('bindImgs', index)
      },
       //优惠券两张排列
       styleCouponTwoDisplayChange(data) {
        this.config.coupon.directionTwo = data
      },
      //优惠券三张排列
      styleCouponDisplayChange(data) {
        this.config.coupon.directionThree = data
      },
      //优惠券四张张排列
      styleCouponFourDisplayChange(data) {
        this.config.coupon.directionFour = data
      },





    },
    mounted() {
      console.log('this is res======',this)
      this.setData(this.res)
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// special.vue?afdf013a